// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DETAILS_LAST_READING_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    detailsLastReadingResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getLastReading({ payload }) {
    try {
        
        let QUERY = `
            query getLastReadingJSON ($accountId: Int!, $deviceId: Int!) {
                result: getLastReadingJSON (accountId: $accountId, deviceId: $deviceId)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(detailsLastReadingResult(data?.result))

    } catch (exc) {
        yield put(detailsLastReadingResult(null))
    }
}

function* watchMethods() {
    yield takeEvery(DETAILS_LAST_READING_REQUEST, getLastReading);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}